define('modules/editor/views/elements/element',['require','exports','module','base/itemview','../../models/editorstate','lib/util','ldsh!../../templates/elements/element_box','../../behaviours/selectable','../../behaviours/movable','../../behaviours/render_with_property_groups','../../behaviours/hoverable','../../behaviours/alignable'],function(require, exports, module) {
  "use strict";

  var ItemView = require("base/itemview"),
      EditorState = require("../../models/editorstate"),
      util = require("lib/util");

  var Controller = {
    onMouseEnter: function(e){
      e.stopPropagation();
      e.stopImmediatePropagation();
      this.$el.addClass("item-hover");
    },
    onMouseLeave: function(e){
      e.stopPropagation();
      this.$el.removeClass("item-hover");
    },
    onToolbarAttached: function(toolbar) {
      toolbar.removeSectionControls();
    },
    _getDragOffset: function(e) {
      var rect = _.clone(this.el.getBoundingClientRect()),
          ev = e.originalEvent,
          left,
          top,
          offset;
      left = rect.left + window.scrollX;
      top = rect.top + window.scrollY;
      return {x: ev.pageX - left, y: ev.pageY - top };
    }
  };

  module.exports = ItemView.extend({
    initialize: function(options) {
      this.data = options.parent.data;
      // Makes element selected when clicked in elements tree
      this.listenTo(this.model, "selectFromTree", function() {
        EditorState.selectElement(this);
      });
      // Makes a rerender of the elements tree when the id is changed
      this.listenTo(this.model.getPropertyGroup('idclass'), "change:id", function(model) {
        EditorState.trigger("idChanged", model);
      });
    },
    // TODO: delete this when I have proper styles
    //attributes: { style: "position: absolute", draggable: "true" },
    className: "ed-item",
    template: require("ldsh!../../templates/elements/element_box"),
    events: {
      "click a": "preventDefault",
      //"mouseenter": "onMouseEnter",
      //"mouseleave": "onMouseLeave"
    },
    preventDefault: function(e){
      e.preventDefault();
      //e.stopPropagation();
    }
  });

  // grepping source code shows Controller is not used
  //util.mixin(module.exports, Controller);
  util.mixin(module.exports, require("../../behaviours/selectable"));
  util.mixin(module.exports, require("../../behaviours/movable"));
  util.mixin(module.exports, require("../../behaviours/render_with_property_groups"));
  util.mixin(module.exports, require("../../behaviours/hoverable"));
  util.mixin(module.exports, require("../../behaviours/alignable"));

});

